// BEGIN GENERATED STOREFRONT POLICY
// Generated by Scripts/generate-storefront-routing.py; edit Patient/storefront-public-routes.json.
export const publicStorefrontPaths = {
  root: "/",
  home: "/home",
  discover: "/discover",
  shop: "/shop",
  shopTreatments: "/shop/treatments",
  shopPackages: "/shop/packages",
  shopProducts: "/shop/products",
  shopMemberships: "/shop/memberships",
  productList: "/products/list",
  shopCategory: "/shop/categories/:id",
  shopCustomCategory: "/shop/custom-category/:id",
  product: "/pdp/product/:id",
  package: "/pdp/package/:id",
  membership: "/pdp/membership/:id",
  productWithSource: "/pdp/product/:id/:source",
  membershipWithSource: "/pdp/membership/:id/:source",
} as const;
const publicPath =
  /^(\/|\/home|\/discover|\/shop|\/shop\/treatments|\/shop\/packages|\/shop\/products|\/shop\/memberships|\/products\/list|\/shop\/categories\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}|\/shop\/custom-category\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}|\/pdp\/product\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}|\/pdp\/package\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}|\/pdp\/membership\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}|\/pdp\/product\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}\/(Package|Treatment)|\/pdp\/membership\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}\/(Package|Treatment))$/;
const publicQueryKey =
  /^(promotion|browseLocation|languageCode|utm_source|utm_medium|utm_campaign|utm_term|utm_content|gclid|fbclid)$/;
// END GENERATED STOREFRONT POLICY

export function isPublicStorefrontRoute(path: string, search: string): boolean {
  return (
    publicPath.test(path) &&
    (search === "" ||
      search
        .slice(1)
        .split("&")
        .every((part) => publicQueryKey.test(part.split("=")[0])))
  );
}
